import classNames from 'clsx';
import React from 'react';
import { useDispatch } from 'react-redux';

import StarsButton from '@swf/components/StarsButton/StarsButton';
import CloseIcon from '@swf/core/assets/icons/close.svg';
import type { Dispatch } from '@swf/core/store';

import styles from './styles.scss';

export interface Props {
  variant?: Variant;
  className?: string;
  onClick?(): void;
  href?: string;
}

export enum Variant {
  Dark = 'dark',
  Light = 'light',
  Float = 'float'
}

const CloseButton: React.FC<Props> = ({ onClick, variant = Variant.Dark, className, href }) => {
  const { modal } = useDispatch<Dispatch>();

  const handleClose = () => {
    if (onClick) {
      onClick();
    }
    modal.close();
  };

  return (
    <StarsButton
      variant="text"
      href={href}
      size={variant === Variant.Float ? 'small' : 'large'}
      className={classNames(styles.close, styles[variant as string], className)}
      icon={<CloseIcon />}
      onClick={href ? undefined : handleClose}
    />
  );
};

export default CloseButton;
